export default __webpack_public_path__ + "static/media/git.04b2f747.svg";